/* Cart drawer extras: reservation timer, product upsells, discount code (applied to the cart directly),
   plus responsive (srcset) product images for upsells and the wishlist. */
(function () {
  if (window.__bfCartExtras) return;
  window.__bfCartExtras = true;

  var CFG = window.BF_CART || { locale: 'de', currency: 'EUR', i18n: {} };
  var T = CFG.i18n;
  var TIMER_KEY = 'bf_cart_reserved_until';
  var DURATION = 10 * 60 * 1000;
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var recCache = {};
  var renderToken = 0;
  var refreshTimer;

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) {}
    return null;
  }

  function money(c) {
    return new Intl.NumberFormat(CFG.locale, { style: 'currency', currency: CFG.currency }).format(c / 100);
  }

  function cents(v) {
    return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : v;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function swapDrawer(html) {
    if (html) {
      window.dispatchEvent(new CustomEvent('theme:cart:drawer:updateHtml', { detail: { section: html } }));
    }
  }

  function updateCart(payload) {
    payload.sections = 'cart-drawer';
    return fetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(payload) }).then(function (r) {
      return r.json();
    });
  }

  /* ---------- Responsive Shopify CDN images ---------- */

  function imageSet(src) {
    var base = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    var sep = base.indexOf('?') > -1 ? '&' : '?';
    return {
      src: base + sep + 'width=800',
      srcset: [400, 600, 800, 1200]
        .map(function (w) {
          return base + sep + 'width=' + w + ' ' + w + 'w';
        })
        .join(', ')
    };
  }

  /* The wishlist script renders 240px thumbnails; swap in a proper srcset so they stay sharp. */
  function upgradeWishlistImages() {
    document.querySelectorAll('.wishlist-item--image img:not([data-bf-hd])').forEach(function (img) {
      var current = img.getAttribute('src');
      if (!current) return;
      var set = imageSet(current);
      img.setAttribute('data-bf-hd', '');
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.setAttribute('sizes', '(max-width: 749px) 45vw, 360px');
      img.setAttribute('srcset', set.srcset);
      img.setAttribute('src', set.src);
    });
  }

  /* ---------- Reservation timer ---------- */

  function endTime() {
    var v = parseInt(store(TIMER_KEY), 10) || 0;
    if (v <= Date.now()) {
      v = Date.now() + DURATION;
      store(TIMER_KEY, String(v));
    }
    return v;
  }

  function tick() {
    var els = document.querySelectorAll('[data-cart-timer]');
    if (!els.length) return;
    var left = Math.max(0, endTime() - Date.now());
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    els.forEach(function (el) {
      el.textContent = txt;
    });
  }

  /* ---------- Discount code: applied to the cart right away, carried to checkout ---------- */

  function applyDiscount(code, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    updateCart({ discount: code })
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) {
          return d.applicable;
        });
        if (!code || ok) {
          swapDrawer(cart.sections && cart.sections['cart-drawer']);
          return;
        }
        // rejected code: remove it again so it does not linger on the cart
        return updateCart({ discount: '' }).then(function (clean) {
          swapDrawer(clean.sections && clean.sections['cart-drawer']);
          setTimeout(function () {
            var msg = document.querySelector('[data-discount-msg]');
            var inp = document.querySelector('.bf-discount__input');
            if (msg) {
              msg.textContent = T.discountInvalid;
              msg.classList.add('is-error');
            }
            if (inp) inp.value = code;
          }, 150);
        });
      })
      .catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  /* ---------- Upsells ---------- */

  function normalize(p) {
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      type: p.product_type || '',
      img: img,
      variants: (p.variants || []).filter(function (v) {
        return v.available;
      })
    };
  }

  function usable(p, inCart) {
    return p.variants.length && p.img && !inCart[p.id] && !/gift/i.test(p.type) && cents(p.variants[0].price) > 0;
  }

  function fetchList(key, url) {
    if (!recCache[key]) {
      recCache[key] = fetch(url)
        .then(function (r) {
          return r.ok ? r.json() : { products: [] };
        })
        .then(function (j) {
          return (j.products || []).map(normalize);
        })
        .catch(function () {
          return [];
        });
    }
    return recCache[key];
  }

  function fetchRecs(pid) {
    return fetchList(pid, '/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related');
  }

  function fetchAll() {
    return fetchList('all', '/collections/all/products.json?limit=30');
  }

  function card(p) {
    var set = imageSet(p.img);
    var url = '/products/' + p.handle;
    var select = '';
    if (p.variants.length > 1) {
      select =
        '<select aria-label="' + esc(T.upsellSize) + '">' +
        p.variants
          .map(function (v) {
            return '<option value="' + v.id + '">' + esc(v.title) + '</option>';
          })
          .join('') +
        '</select>';
    }
    return (
      '<div class="bf-up" data-variant="' + p.variants[0].id + '">' +
      '<a class="bf-up__img" href="' + url + '"><img src="' + set.src + '" srcset="' + set.srcset + '" sizes="(max-width: 749px) 40vw, 220px" alt="' + esc(p.title) + '" loading="lazy" width="400" height="500"></a>' +
      '<a class="bf-up__title" href="' + url + '">' + esc(p.title) + '</a>' +
      '<span class="bf-up__price">' + money(cents(p.variants[0].price)) + '</span>' +
      select +
      '<button type="button" data-upsell-add>' + esc(T.upsellAdd) + '</button>' +
      '</div>'
    );
  }

  function renderUpsells() {
    var box = document.querySelector('[data-cart-upsells]');
    if (!box) return;
    var token = ++renderToken;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items.length) return null;

        var inCart = {};
        var seeds = [];
        cart.items.forEach(function (i) {
          inCart[i.product_id] = true;
          if (seeds.indexOf(i.product_id) < 0 && seeds.length < 2) seeds.push(i.product_id);
        });

        return Promise.all(seeds.map(fetchRecs)).then(function (lists) {
          var out = [];
          var seen = {};
          function add(list) {
            list.forEach(function (p) {
              if (out.length < 8 && !seen[p.id] && usable(p, inCart)) {
                seen[p.id] = true;
                out.push(p);
              }
            });
          }
          lists.forEach(add);
          if (out.length < 4) {
            return fetchAll().then(function (all) {
              add(all);
              return out;
            });
          }
          return out;
        });
      })
      .then(function (list) {
        if (token !== renderToken || !list) return;
        var track = box.querySelector('[data-upsells-track]');
        if (!list.length) {
          box.hidden = true;
          return;
        }
        track.innerHTML = list.map(card).join('');
        box.hidden = false;
      })
      .catch(function () {});
  }

  function syncCartCount() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        var count = document.querySelector('[data-cart-count]');
        if (count) count.setAttribute('data-cart-count', c.item_count);
        var layout = document.querySelector('.layout--viewport');
        if (layout) layout.setAttribute('data-cart-empty', c.item_count === 0);
      })
      .catch(function () {});
  }

  function addUpsell(btn) {
    var cardEl = btn.closest('.bf-up');
    var select = cardEl.querySelector('select');
    var id = parseInt(select ? select.value : cardEl.getAttribute('data-variant'), 10);
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer' })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || 'error');
          return j;
        });
      })
      .then(function (j) {
        swapDrawer(j.sections && j.sections['cart-drawer']);
        syncCartCount();
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = T.upsellError;
        setTimeout(function () {
          btn.textContent = label;
        }, 2500);
      });
  }

  /* ---------- Wiring ---------- */

  function refresh() {
    if (!document.querySelector('[data-cart-timer]')) store(TIMER_KEY, null);
    tick();
    renderUpsells();
    upgradeWishlistImages();
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 60);
  }

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-discount-apply]');
    if (apply) {
      e.preventDefault();
      var code = apply.closest('.bf-discount').querySelector('.bf-discount__input').value.trim();
      if (code) applyDiscount(code, apply);
      return;
    }
    if (e.target.closest('[data-discount-remove]')) {
      e.preventDefault();
      applyDiscount('', null);
      return;
    }
    var add = e.target.closest('[data-upsell-add]');
    if (add) {
      e.preventDefault();
      addUpsell(add);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('bf-discount__input')) {
      e.preventDefault();
      e.target.closest('.bf-discount').querySelector('[data-discount-apply]').click();
    }
  });

  ['theme:cart:updated', 'theme:cart:drawer:updateHtml', 'theme:transition:reload:cart-drawer', 'wishlist:updated'].forEach(function (name) {
    window.addEventListener(name, scheduleRefresh);
  });

  /* The wishlist panel is (re)rendered asynchronously: watch for new thumbnails */
  var upgradeFrame = 0;
  new MutationObserver(function () {
    if (upgradeFrame) return;
    upgradeFrame = requestAnimationFrame(function () {
      upgradeFrame = 0;
      upgradeWishlistImages();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  setInterval(tick, 1000);
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
})();